module.exports = __webpack_public_path__ + "img/service-bg2.90b074a4.png";